import { makeStyles, Theme, createMuiTheme } from '@material-ui/core/styles';
import { blue } from '@material-ui/core/colors';

export const wrapperTheme = createMuiTheme({
  overrides: {
    MuiList: {
      padding: {
        width: 110,
      },
    },
    MuiPaper: {
      root: {
        borderRadius: 4,
      },
    },
    MuiIconButton: {
      root: {
        '&:hover': {
          backgroundColor: '#ff505f3b',
        },
      },
    },
  },
  palette: {
    primary: {
      main: '#007DFF',
      dark: '#007DFF',
    },
  },
});

export const useStyles = makeStyles(
  (theme: Theme) => ({
    dateRangeButton: {
      width: 180,
      height: 50,
      fontSize: 14,
      textTransform: 'none',
      boxShadow: 'none',
      color: theme.palette.getContrastText(blue[500]),
      backgroundColor: '#FF505F',
      '&:hover': {
        backgroundColor: '#f74050',
      },
    },
    dateRangePopUp: {
      position: 'absolute',
      marginTop: theme.spacing(0.5),
      // '& .MuiList-padding': {
      //   width: 110,
      // },
      '& [class*="materialui-daterange-picker-makeStyles-button-15"]': {
        '&:hover': {
          backgroundColor: '#ff505f3b',
        },
      },
      '& [class*="materialui-daterange-picker-makeStyles-highlighted"]': {
        backgroundColor: 'rgba(255, 80, 95, 0.12)',
      },
      '& [class*="materialui-daterange-picker-makeStyles-outlined"]': {
        borderColor: '#FF505F',
      },
      '& [class*="materialui-daterange-picker-makeStyles-filled"]': {
        backgroundColor: '#FF505F',
      },
    },
  }),
  {
    index: 1,
  }
);
